import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Abmelden")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ionIcon = _resolveComponent("ionIcon")
  const _component_ionLabel = _resolveComponent("ionLabel")
  const _component_ionTabButton = _resolveComponent("ionTabButton")
  const _component_ion_badge = _resolveComponent("ion-badge")
  const _component_ionTabBar = _resolveComponent("ionTabBar")
  const _component_ionTabs = _resolveComponent("ionTabs")
  const _component_IonPage = _resolveComponent("IonPage")

  return (_openBlock(), _createBlock(_component_IonPage, null, {
    default: _withCtx(() => [
      _createVNode(_component_ionTabs, null, {
        default: _withCtx(() => [
          _createVNode(_component_ionTabBar, {
            class: "custom-tab-bar",
            slot: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ionTabButton, {
                href: "/tables",
                tab: "tab1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ionIcon, { icon: $setup.addCircleOutline }, null, 8, ["icon"]),
                  _createVNode(_component_ionLabel, null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ionTabButton, {
                href: "/openratings",
                tab: "tab2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ionIcon, {
                    color: $options.getOpenRatingsCount > 0 ? 'danger' : 'primary',
                    icon: $setup.alertCircleOutline
                  }, null, 8, ["color", "icon"]),
                  _createVNode(_component_ionLabel, null, {
                    default: _withCtx(() => [
                      ($options.getOpenRatingsCount > 0)
                        ? (_openBlock(), _createBlock(_component_ion_badge, {
                            key: 0,
                            color: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($options.getOpenRatingsCount) + " Offene Bewertungen", 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock("span", _hoisted_2, "Offene Bewertungen "))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ionTabButton, {
                href: "/logout",
                tab: "tab3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ionIcon, { icon: $setup.logInOutline }, null, 8, ["icon"]),
                  _createVNode(_component_ionLabel, null, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}